import React, { useMemo } from 'react';
import { usePricingState } from '../state/pricing.state';
import { ITier } from '../../../data/tiers';

export interface IPriceTag {
    tier: ITier;
}

export const PriceTag: React.FC<IPriceTag> = (props) => {
    const { tier } = props;

    const { mode } = usePricingState();

    const price = useMemo(() => {
        if (mode === 'annual') {
            return tier.priceMonthlyDiscounted;
        }

        return tier.priceMonthly;
    }, [mode, tier.priceMonthly, tier.priceMonthlyDiscounted]);

    return (
        <div className="relative flex w-max flex-col gap-1">
            <span className="mt-4 w-max whitespace-nowrap rounded-full bg-neutral-700/50 px-4 py-1 font-bold text-3xl tracking-wide text-neutral-50 backdrop-blur-2xl">
                {price &&
                    price > 0 &&
                    new Intl.NumberFormat('de-DE', {
                        style: 'currency',
                        currency: 'EUR',
                    }).format(price)}
                {!tier.priceMonthly && 'contact us'}
            </span>
            {tier.showVat && (
                <span className="self-end pr-2 text-xs text-neutral-400">per month – ex. VAT</span>
            )}
        </div>
    );
};
